export enum SortConstants {
    ASC = 'asc',
    ASCENDING = ASC,
    DESC = 'desc',
    DESCENDING = DESC
}
